import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  listStyle: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    elevation: 0,
    shadowOpacity: 0,
  },
  headerContainerStyle: theme => ({
    paddingHorizontal: 0,
  }),
  headerStyle: {
    fontSize: 29.1,
    lineHeight: 37.4,
    letterSpacing: 0,
    fontWeight: 'bold',
    color: Colors.dark_grey,
  },
  listItemContainerStyle: theme => ({
    paddingVertical: 20,
    paddingHorizontal: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorNine,
  }),
  listItemRightIconStyle: {
    marginHorizontal: 5,
  },
  listItemTextStyle: theme => ({
    fontSize: 18.7,
    lineHeight: 24,
    letterSpacing: 0,
    color: theme.colors.headerTitleColor,
  }),
});
